import React from "react";
import Menu from "../Menu/Menu";

const Blogs = () => {
  return (
    <div className="container mx-auto px-4 md:px-0 min-h-screen py-20">
      <Menu />
      <h2>Blog coming soon.........</h2>
    </div>
  );
};

export default Blogs;
